export default __webpack_public_path__ + "static/media/ic-other-notification-02.f860dedf.svg";